var map = {
	"./ai/logoPagePhone.png": 394,
	"./computernaya-gramotnost/logoPagePhone.png": 395,
	"./ege-informatika/logoPagePhone.png": 396,
	"./frontend/logoPagePhone.png": 397,
	"./game-design/logoPagePhone.png": 398,
	"./graphic-design/logoPagePhone.png": 399,
	"./intensive/logoPagePhone.png": 400,
	"./osnovy-programmirovaniya/logoPagePhone.png": 401,
	"./predprinimatelstvo/logoPagePhone.png": 402,
	"./python/logoPagePhone.png": 403,
	"./scratch/logoPagePhone.png": 404,
	"./unity/logoPagePhone.png": 405,
	"./videoblogging/logoPagePhone.png": 406,
	"./web-razrabotka/logoPagePhone.png": 407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 751;